import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c22ce512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-resources-diets-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Popis prehrane ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorResourcesDietsListFormCreateIndexVue = _resolveComponent("AppAdministratorResourcesDietsListFormCreateIndexVue")!
  const _component_AppAdministratorResourcesDietsListFormUpdateIndexVue = _resolveComponent("AppAdministratorResourcesDietsListFormUpdateIndexVue")!
  const _component_AppAdministratorResourcesDietsListFormRemoveIndexVue = _resolveComponent("AppAdministratorResourcesDietsListFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorResourcesDietsListFormCreateIndexVue, { onGetDiets: _ctx.getDiets }, null, 8, ["onGetDiets"])
      ]),
      (_ctx.diets.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diets, (diet) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: diet.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(diet.content.name), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AppAdministratorResourcesDietsListFormUpdateIndexVue, {
                    diet: diet,
                    onGetDiets: _ctx.getDiets
                  }, null, 8, ["diet", "onGetDiets"]),
                  _createVNode(_component_AppAdministratorResourcesDietsListFormRemoveIndexVue, {
                    diet: diet,
                    onGetDiets: _ctx.getDiets
                  }, null, 8, ["diet", "onGetDiets"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, " Nema podataka... "))
    ])
  ]))
}